import { VerificationService } from '@sheerid/jslib';
import { STAGING_SUCCESS_REDIRECT, PRODUCTION_SUCCESS_REDIRECT } from '../constants';

export const getSuccessRedirect = (verificationService: VerificationService) => {
    let redirectDestination;

    if (verificationService.programTheme.isTestMode) {
        redirectDestination = STAGING_SUCCESS_REDIRECT;
    } else {
        redirectDestination = PRODUCTION_SUCCESS_REDIRECT;
    }

    return redirectDestination;
};
